import './date-picker';
import roomBooking from './room-booking';
import './status-message';

if (document.querySelectorAll("#room-booking-container").length) {

    module.exports = {
        template: '#room-booking-container',
        components: {
            roomBooking
        }
    }
}